// convert original.png -modulate 100,120 -resize 128x static-map-backdrop.jpg
import backgroundImage from '../images/static-map-backdrop.jpg';

import '../styles/static_backdrop.css';
import { SyncReactNode } from '../types';

const StaticBackdrop = ({ children }: { children: SyncReactNode }) => (
  <div className="static-backdrop-container">
    <div
      className="static-backdrop-backdrop"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    />
    {children}
  </div>
);

export default StaticBackdrop;
